import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-close-session',
    templateUrl: './close-session.component.html',
    styleUrls: ['./close-session.component.scss', '../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class CloseSessionComponent implements OnInit {

  private router = inject(Router);
  public isLoading: boolean = false;

  constructor() { };

  ngOnInit(): void {
    localStorage.clear();
  }

  public Reload(): void {
    this.isLoading = true;

    setTimeout(() => {
      this.router.navigate(['']);
    }, 3000);

  }

}

